import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { GeneralRoutePaths } from '../../enums/route-types.enum';
import { ImpersonateService } from '../../impersonate/impersonate.service';
import { CoverageSessionService } from '../../services/coverage/coverage-session.service';

export const leaveAndCoverageAccessGuard: CanActivateFn = () => {
  const coverageSessionService = inject(CoverageSessionService);
  const impersonateService = inject(ImpersonateService);
  const router = inject(Router);

  if (coverageSessionService.isCoveringActive() || impersonateService.impersonated()) {
    return router.createUrlTree([GeneralRoutePaths.PAGE_NOT_FOUND]);
  }

  return true;
};
